import React from "react";
import { styled } from "@mui/material";

const StyledBox = styled((props) => {
  const { component: Component = "svg", ...other } = props;

  return <Component {...other} />;
})(({ theme }) => ({
  display: "inline-block",
  userSelect: "none",
  fill: "currentColor",
  flexShrink: 0,
  transition: theme.transitions.create("fill", {
    duration: theme.transitions.duration.shorter,
  }),
}));

export { StyledBox };
